import { BrowserModule, Meta, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { AppComponent } from './app.component';
import { MainComponent } from './Main/Main.component';
import { HomeComponent } from './Pages/Home/Home.component';
import { AppRoutingModule } from './app-routing.module';
import { WidgetsModule } from './Widgets/Widgets.module';
import { MenuComponent } from './Layouts/Menu/HeaderMenu/HeaderMenu/HeaderMenu.component';
import { HeaderOneComponent } from './Layouts/Header/HeaderOne/HeaderOne.component';
import { TemplateModule } from './Template/Template.module';
import { FooterOneComponent } from './Layouts/Footer/FooterOne/FooterOne.component';
import { FooterMenuComponent } from './Layouts/Menu/FooterMenu/FooterMenu/FooterMenu.component';
import { MenuItems } from './Core/Menu/MenuItems/MenuItems';
import { DropletService } from './Services/Droplet.service';
import { StickyheaderComponent } from './Layouts/Header/StickyHeader/StickyHeader.component';
import { SessionModule } from './Pages/Session/Session.module';
import { GuardService } from './Services/Auth/guard.service';
import { ApiService } from './Services/Api.service';
import { StatesService } from './Services/states.service';
import { PublicGuardService } from './Services/Auth/publicGuard.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment.prod';
// import { NguiMapModule} from '@ngui/map';
import { AgmCoreModule } from '@agm/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EventsService } from './Services/Events.service';
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import { CookiesComponent } from './Pages/cookies/cookies.component';
import { ThankPageComponent } from './Pages/thank-page/thank-page.component';
import { ThankPageBlogSuscriptionComponent } from './Pages/thank-page-blog-suscription/thank-page-blog-suscription.component'

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname,
   
  },
  content: {
    message: 'Ao navegar neste site, você aceita os cookies que usamos para melhorar sua experiência.',
    link: 'Mais informações.',
    href:'/cookies',
    target:'_self',
    allow: 'Entendi',
    deny: 'Não',
    policy: 'Política de Cookies'
 
  },
  palette: {
    popup: {
      background: '#fff'
    },
    button: {
      background: '#90d7d7'
    }
  },
  theme: 'edgeless',
  type: 'opt-out'
};

export function HttpLoaderFactory(http: HttpClient) {
   return new TranslateHttpLoader(http);
}

@NgModule({
   declarations: [
      AppComponent,
      MainComponent,
      HomeComponent,
      MenuComponent,
      HeaderOneComponent,
      FooterOneComponent,
      FooterMenuComponent,
      StickyheaderComponent,
      CookiesComponent,
      ThankPageComponent,
      ThankPageBlogSuscriptionComponent,
     
   ],
   imports: [
      BrowserModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      WidgetsModule,
      TemplateModule,
      HttpClientModule,
      SessionModule,
      TranslateModule,
      // NguiMapModule.forRoot({apiUrl: 'https://maps.google.com/maps/api/js?key='+environment.apiKeyMap+''}),
      LoadingBarRouterModule,
      AgmCoreModule.forRoot({
         apiKey: environment.apiKeyMap,
         libraries: ['places']
       }),
      LoadingBarModule,
      TranslateModule.forRoot({
         loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
         }
      }),
      NgcCookieConsentModule.forRoot(cookieConfig)
   ],
   providers: [
      MenuItems,
      DropletService,
      ApiService,
      GuardService,
      PublicGuardService,
      EventsService,
      StatesService,
      Meta,
      Title
   ],
   exports: [],
   bootstrap: [AppComponent]
})

export class AppModule { }
